const LocalStorageKey = Object.freeze({
    jwtUserToken:"jwtUserToken",
    originalRandomizedQuestionnaire:"originalRandomizedQuestionnaire",
    QuestionnaireUserResponses:"QuestionnaireUserResponses",
    currentQuestionnairePage : "currentQuestionnairePage",
    totalQuestionnairePages : "totalQuestionnairePages",
    allCharacterTypeColors : 'allCharacterTypeColors',
    allCharacterTypeNames : 'allCharacterTypeNames',
    allCharacterTypesDataPoints : 'allCharacterTypesDataPoints',
    allQuestionnaireResponseDataPoints : 'allQuestionnaireResponseDataPoints',
    allScatterChartDataPoints : 'allScatterChartDataPoints',
    mostTwoDominantCharacterTypes : 'mostTwoDominantCharacterTypes',
    apiResourcesAndActions : 'apiResourcesAndActions',
    customerResourcesAndActions : 'customerResourcesAndActions',
    frontEndResourcesAndActions : 'frontEndResourcesAndActions',
    standardSessionDuration : 'standardSessionDuration'

});

export default LocalStorageKey;